import { motion } from "framer-motion";
import { Layers, ThermometerSnowflake, Building2, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: Layers,
    title: "Bitumen & EPDM Dakbedekking",
    desc: "Wij leveren platte daken 100% waterdicht af met hoogwaardige bitumen en EPDM systemen — duurzaam en onderhoudsarm.",
    tag: "01",
  },
  {
    icon: ThermometerSnowflake,
    title: "Dakisolatie",
    desc: "Bespaar aanzienlijk op uw energiekosten met professionele na-isolatie volgens de laatste normen en premievoorwaarden.",
    tag: "02",
  },
  {
    icon: Building2,
    title: "Grootschalige Renovatie",
    desc: "Gespecialiseerd in projecten vanaf 100 m² voor appartementen, bedrijfspanden en collectieve renovaties.",
    tag: "03",
  },
];

export const Services = () => {
  return (
    <section id="diensten" data-testid="services-section" className="py-24 md:py-32 bg-sefco-bg">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-16"
        >
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-sefco-blue" />
            <span className="text-sm uppercase tracking-[0.2em] text-zinc-400 font-medium">Wat we doen</span>
          </div>
          <h2 className="font-heading font-bold text-white text-3xl sm:text-5xl tracking-tight">Onze Diensten</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-neutral-800">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.12 }}
                className="group relative border-r border-b border-neutral-800 bg-sefco-surfaceAlt p-8 md:p-10 hover:bg-sefco-surface transition-colors"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="border border-neutral-700 group-hover:border-sefco-blue p-4 transition-colors">
                    <Icon size={30} strokeWidth={1.5} className="text-white group-hover:text-sefco-blue transition-colors" />
                  </div>
                  <span className="font-heading font-black text-5xl text-neutral-800 group-hover:text-sefco-blue/30 transition-colors">
                    {s.tag}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-xl sm:text-2xl text-white mb-3">{s.title}</h3>
                <p className="text-zinc-400 leading-relaxed">{s.desc}</p>
                <div className="mt-8 h-px w-full bg-neutral-800 group-hover:bg-sefco-blue transition-colors" />
                <div className="mt-4 flex items-center gap-2 text-sm uppercase tracking-wider text-zinc-500 group-hover:text-white transition-colors">
                  Meer info <ArrowUpRight size={16} />
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
